import ad_track from './ad_track/index';
import album from './album/index';
import camera from './camera/index';
import check_app_status from './check_app_status/index';
import checkinmessageupdate from './checkinmessageupdate/index';
import close_page from './close_page/index';
import copy_text from './copy_text/index';
import delete_app_task from './delete_app_task/index';
import execute_tasks from './execute_tasks/index';
import forward from './forward/index';
import game_appointment from './game_appointment/index';
import get_app_task from './get_app_task/index';
import get_common from './get_common/index';
import get_coupon_list from './get_coupon_list/index';
import get_entrance_param from './get_entrance_param/index';
import get_game_appointments from './get_game_appointments/index';
import get_location from './get_location/index';
import get_network from './get_network/index';
import get_partner_userinfo from './get_partner_userinfo/index';
import get_storage from './get_storage/index';
import get_sys from './get_sys/index';
import get_user from './get_user/index';
import get_user_installed_applist from './get_user_installed_applist/index';
import get_uuid from './get_uuid/index';
import h5_directpay from './h5_directpay/index';
import h5_pay_to_native from './h5_pay_to_native/index';
import handshake from "./handshake/index";
import is_ready_videos from "./is_ready_videos/index";
import linkDesk from './linkDesk/index';
import load_page from './load_page/index';
import log from './log/index';
import login from './login/index';
import login_status from './login_status/index';
import logout from './logout/index';
import native_pay from "./native_pay/index";
import nativeto_h5_reload from "./nativeto_h5_reload/index";
import notice_activate_tencent_king_card from "./notice_activate_tencent_king_card/index";
import notice_checkinhomeinfoupdate from "./notice_checkinhomeinfoupdate/index";
import notice_coupon_selected from './notice_coupon_selected/index';
import notice_ios_h5_pay from './notice_ios_h5_pay/index';
import notify_danmustyle_ischanged from './notify_danmustyle_ischanged/index';
import play_ad_videos from './play_ad_videos/index';
import preloading_ad_videos from './preloading_ad_videos/index';
import receive_freecard_change from './receive_freecard_change/index';
import receive_page_status from './receive_page_status/index';
import refresh_pay_page from './refresh_pay_page/index';
import register_task_listener from './register_task_listener/index';
import register_third_app_open from './register_third_app_open/index';
import remove_storage from './remove_storage/index';
import report_lifetime from './report_lifetime/index';
import request_api from './request_api/index';
import save_jpeg_image_base64 from './save_jpeg_image_base64/index';
import scroll_whitearea from './scroll_whitearea/index';
import set_3dtouch from './set_3dtouch/index';
import set_forIos_idfa from './set_forIos_idfa/index';
import set_keyboard from './set_keyboard/index';
import set_navback_btn from './set_navback_btn/index';
import set_screen_display from './set_screen_display/index';
import set_slideback from './set_slideback/index';
import set_storage from './set_storage/index';
import set_title from './set_title/index';
import share from './share/index';
import show_loading from './show_loading/index';
import show_tips from './show_tips/index';
import switch_page from './switch_page/index';
import upload_image from './upload_image/index';

export {
  ad_track,
  album,
  camera,
  check_app_status,
  checkinmessageupdate,
  close_page,
  copy_text,
  delete_app_task,
  execute_tasks,
  forward,
  game_appointment,
  get_app_task,
  get_common,
  get_coupon_list,
  get_entrance_param,
  get_game_appointments,
  get_location,
  get_network,
  get_partner_userinfo,
  get_storage,
  get_sys,
  get_user,
  get_user_installed_applist,
  get_uuid,
  h5_directpay,
  h5_pay_to_native,
  handshake,
  is_ready_videos,
  linkDesk,
  load_page,
  log,
  login,
  login_status,
  logout,
  native_pay,
  nativeto_h5_reload,
  notice_activate_tencent_king_card,
  notice_checkinhomeinfoupdate,
  notice_coupon_selected,
  notice_ios_h5_pay,
  notify_danmustyle_ischanged,
  play_ad_videos,
  preloading_ad_videos,
  receive_freecard_change,
  receive_page_status,
  refresh_pay_page,
  register_task_listener,
  register_third_app_open,
  remove_storage,
  report_lifetime,
  request_api,
  save_jpeg_image_base64,
  scroll_whitearea,
  set_3dtouch,
  set_forIos_idfa,
  set_keyboard,
  set_navback_btn,
  set_screen_display,
  set_slideback,
  set_storage,
  set_title,
  share,
  show_loading,
  show_tips,
  switch_page,
  upload_image
}



// WEBPACK FOOTER //
// ./node_modules/@kk/h5-sdk/src/index.js